import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        padding: theme.spacing(1, 2),
        margin: theme.spacing(0.3),
        fontSize: theme.typography.pxToRem(12),
        borderRadius: 20,
        border: '1px solid #E5EBEE',
        backgroundColor: theme.palette.common.white,
    },
    clickable: {
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#CDE6FF',
        },
    },
    selected: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    disabled: {
        cursor: 'auto',
        '&:hover': {
            color: '#606060',
            backgroundColor: theme.palette.common.white,
        },
    },
}));
